import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

// @NOTE This is used in `gatsby-browser.js` and sent along with the generic `analytics.page()` event
const NodeTypeTracker = ({ nodeType }) => {
  return <Helmet meta={[{ name: 'node-type', content: nodeType }]} />
}

NodeTypeTracker.propTypes = {
  nodeType: PropTypes.string.isRequired,
}

export default NodeTypeTracker
